import App from './App.svelte';

const srcTag = document.querySelector('[data-client-key]');

let clientKey = srcTag.getAttribute('data-client-key');

let domTarget;
const isDomTargetExist = srcTag.hasAttribute('dom-target');


if (isDomTargetExist) {
	const targetedSelector = srcTag.getAttribute('dom-target');
	domTarget = document.getElementById(`${targetedSelector}`);
} else {
	const container = document.createElement('div');
	container.id = 'superyou_leadgen';
	document.body.appendChild(container);

	domTarget = document.getElementById('superyou_leadgen');
}

const app = new App({
	target: domTarget,
	props: {
		clientKey: clientKey
	}
});

// const app = new App({
// 	target: document.body,
// });

export default app;